(function () {
  if (window.__mjInit) return;
  window.__mjInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var observer = null;

  function initReveal(root) {
    var els = (root || document).querySelectorAll('.mj-reveal:not(.mj-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mj-visible'); });
      return;
    }
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('mj-visible');
          observer.unobserve(e.target);
          if (e.target.hasAttribute('data-mj-count')) countUp(e.target);
          e.target.querySelectorAll('[data-mj-count]').forEach(countUp);
        });
      }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    }
    els.forEach(function (el) { observer.observe(el); });
  }

  function countUp(el) {
    if (el.dataset.mjDone) return;
    el.dataset.mjDone = '1';
    var target = parseFloat(el.dataset.mjCount) || 0;
    var decimals = (el.dataset.mjCount.split('.')[1] || '').length;
    var prefix = el.dataset.mjPrefix || '';
    var suffix = el.dataset.mjSuffix || '';
    var fmt = function (n) {
      return prefix + n.toLocaleString('es-CL', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }) + suffix;
    };
    if (reduce) { el.textContent = fmt(target); return; }
    var dur = 1600, start = null;
    function step(t) {
      if (!start) start = t;
      var p = Math.min((t - start) / dur, 1);
      var eased = 1 - Math.pow(1 - p, 3);
      el.textContent = fmt(target * eased);
      if (p < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }

  function initHero(root) {
    (root || document).querySelectorAll('[data-mj-hero]').forEach(function (hero) {
      if (hero.dataset.mjInit) return;
      hero.dataset.mjInit = '1';
      var slides = hero.querySelectorAll('.mj-hero__slide');
      var dots = hero.querySelectorAll('.mj-hero__dot');
      if (slides.length < 2) return;
      var speed = (parseInt(hero.dataset.speed, 10) || 6) * 1000;
      var auto = hero.dataset.autoplay === 'true' && !reduce;
      var idx = 0, timer = null;
      function go(i) {
        slides[idx].classList.remove('is-active');
        dots[idx] && dots[idx].classList.remove('is-active');
        idx = (i + slides.length) % slides.length;
        slides[idx].classList.add('is-active');
        if (dots[idx]) {
          // reinicia la barra de progreso
          dots[idx].classList.remove('is-active');
          void dots[idx].offsetWidth;
          dots[idx].classList.add('is-active');
        }
        restart();
      }
      function restart() {
        clearTimeout(timer);
        if (auto && !hero.classList.contains('is-paused')) timer = setTimeout(function () { go(idx + 1); }, speed);
      }
      dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
      hero.addEventListener('mouseenter', function () { hero.classList.add('is-paused'); clearTimeout(timer); });
      hero.addEventListener('mouseleave', function () { hero.classList.remove('is-paused'); restart(); });
      var x0 = null;
      hero.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      hero.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) go(idx + (dx < 0 ? 1 : -1));
        x0 = null;
      });
      restart();
    });
  }

  function initMagnetic(root) {
    if (reduce || !window.matchMedia('(hover: hover)').matches) return;
    (root || document).querySelectorAll('[data-mj-magnetic]').forEach(function (card) {
      if (card.dataset.mjInit) return;
      card.dataset.mjInit = '1';
      var max = parseFloat(card.dataset.mjMagnetic) || 6;
      card.addEventListener('mousemove', function (e) {
        var r = card.getBoundingClientRect();
        var x = (e.clientX - r.left) / r.width, y = (e.clientY - r.top) / r.height;
        card.style.setProperty('--mx', (x * 100) + '%');
        card.style.setProperty('--my', (y * 100) + '%');
        card.style.transform = 'rotateX(' + ((0.5 - y) * max) + 'deg) rotateY(' + ((x - 0.5) * max) + 'deg) translateY(-4px)';
      });
      card.addEventListener('mouseleave', function () { card.style.transform = ''; });
    });
  }

  function initFaq(root) {
    (root || document).querySelectorAll('.mj-faq__q').forEach(function (btn) {
      if (btn.dataset.mjInit) return;
      btn.dataset.mjInit = '1';
      btn.addEventListener('click', function () {
        var item = btn.closest('.mj-faq__item');
        var open = item.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  function initAll(e) {
    var root = e && e.target && e.target.querySelectorAll ? e.target : document;
    initReveal(root); initHero(root); initMagnetic(root); initFaq(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
